import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";

export const PrimaryButton = ({ to, href, children, icon: Icon = ArrowRight, testId, className = "", ...rest }) => {
  const cls = `glow-btn inline-flex items-center justify-center gap-2 rounded-full bg-electric px-7 py-4 text-sm md:text-base font-semibold text-white tracking-wide ${className}`;
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testId} {...rest}>
        {children}
        <Icon className="h-4 w-4" />
      </Link>
    );
  return (
    <a href={href} className={cls} data-testid={testId} {...rest}>
      {children}
      <Icon className="h-4 w-4" />
    </a>
  );
};

export const GhostButton = ({ to, href, children, testId, className = "", ...rest }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/5 px-7 py-4 text-sm md:text-base font-semibold text-white hover:border-electric hover:bg-electric/10 transition-all ${className}`;
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testId} {...rest}>
        {children}
      </Link>
    );
  return (
    <a href={href} className={cls} data-testid={testId} {...rest}>
      {children}
    </a>
  );
};

export const WhatsAppButton = ({ children = "Chat on WhatsApp", testId = "whatsapp-button" }) => (
  <a
    href="https://wa.me/2348147276648"
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EB257] px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-emerald-500/20 transition-all"
  >
    <MessageCircle className="h-4 w-4" />
    {children}
  </a>
);
